"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeToken = exports.clearCallbacks = exports.getCurrentUserEmail = exports.getTokenParsed = exports.getToken = exports.clearTokenExchange = exports.getTokenExchangeParsed = exports.setTokenExchange = exports.getTokenExchange = exports.impersonate = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var impersonate = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
keycloackClient, requestedSubject, subjectToken) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var tokenExchange;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!keycloackClient || !requestedSubject || !subjectToken) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, (0, exports.getTokenExchange)(requestedSubject, subjectToken)];
            case 1:
                tokenExchange = _a.sent();
                if (!tokenExchange) {
                    return [2 /*return*/];
                }
                (0, exports.setTokenExchange)(keycloackClient, tokenExchange);
                return [2 /*return*/];
        }
    });
}); };
exports.impersonate = impersonate;
var getTokenExchange = function (requestedSubject, subjectToken) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var params, config, response, error_1;
    var _a;
    return (0, tslib_1.__generator)(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!requestedSubject || !subjectToken) {
                    return [2 /*return*/, undefined];
                }
                params = new URLSearchParams();
                params.append('client_id', process.env.REACT_APP_KEYCLOAK_CLIENTID);
                params.append('grant_type', 'urn:ietf:params:oauth:grant-type:token-exchange');
                params.append('requested_subject', requestedSubject);
                params.append('subject_token', subjectToken);
                params.append('requested_token_type', 'urn:ietf:params:oauth:token-type:refresh_token');
                params.append('audience', process.env.REACT_APP_KEYCLOAK_CLIENTID);
                config = {
                    baseURL: process.env.REACT_APP_KEYCLOAK_URL,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Authorization: "Bearer ".concat(subjectToken),
                    },
                };
                response = undefined;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post("/realms/".concat(process.env.REACT_APP_KEYCLOAK_REALM, "/protocol/openid-connect/token"), params, config)];
            case 2:
                response = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _b.sent();
                console.log(error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.status) === 200 && !!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.access_token)
                    ? response.data.access_token
                    : undefined];
        }
    });
}); };
exports.getTokenExchange = getTokenExchange;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var setTokenExchange = function (keycloackClient, token) {
    if (!keycloackClient || !token) {
        return;
    }
    keycloackClient.tokenExchange = token;
    keycloackClient.tokenExchangeParsed = (0, exports.decodeToken)(token);
};
exports.setTokenExchange = setTokenExchange;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getTokenExchangeParsed = function (keycloackClient) {
    return keycloackClient && keycloackClient.authenticated
        ? keycloackClient.tokenExchangeParsed
        : undefined;
};
exports.getTokenExchangeParsed = getTokenExchangeParsed;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var clearTokenExchange = function (keycloackClient) {
    if (!keycloackClient) {
        return;
    }
    delete keycloackClient.tokenExchange;
    delete keycloackClient.tokenExchangeParsed;
};
exports.clearTokenExchange = clearTokenExchange;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getToken = function (keycloackClient) {
    return keycloackClient && keycloackClient.authenticated
        ? keycloackClient.tokenExchange || keycloackClient.token
        : undefined;
};
exports.getToken = getToken;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getTokenParsed = function (keycloackClient) {
    return keycloackClient && keycloackClient.authenticated
        ? keycloackClient.tokenExchangeParsed || keycloackClient.tokenParsed
        : undefined;
};
exports.getTokenParsed = getTokenParsed;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCurrentUserEmail = function (keycloackClient) {
    var _a, _b;
    return keycloackClient && keycloackClient.authenticated
        ? ((_a = keycloackClient.tokenExchangeParsed) === null || _a === void 0 ? void 0 : _a.email) ||
            ((_b = keycloackClient.tokenParsed) === null || _b === void 0 ? void 0 : _b.email)
        : undefined;
};
exports.getCurrentUserEmail = getCurrentUserEmail;
var clearCallbacks = function () {
    var keys = [];
    for (var i = 0, l = localStorage.length; i < l; ++i) {
        var key = localStorage.key(i);
        if (/kc-callback-.*/i.test(key)) {
            keys.push(key);
        }
    }
    for (var i = 0, l = keys.length; i < l; ++i) {
        localStorage.removeItem(keys[i]);
    }
};
exports.clearCallbacks = clearCallbacks;
var decodeToken = function (str) {
    str = str.split('.')[1];
    str = str.replace(/-/g, '+');
    str = str.replace(/_/g, '/');
    switch (str.length % 4) {
        case 0:
            break;
        case 2:
            str += '==';
            break;
        case 3:
            str += '=';
            break;
        default:
            throw 'Invalid token';
    }
    str = decodeURIComponent(escape(atob(str)));
    str = JSON.parse(str);
    return str;
};
exports.decodeToken = decodeToken;
